import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Card, Dropdown, Form, Grid, Menu, Pagination, Table } from 'semantic-ui-react';
import PageContainer from '../../common/PageContainer';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import * as moment from 'moment';
import { SERVER_URL } from '../../../constants';
import { useFormik } from 'formik';
import { PromoStatusLabel } from '../DigestStatusLabel';
import * as api from './../../../api/campaignApi';

export const PromoAlertSearch = ({
  cities,
  promoAlertFormats,
  clearRecentPosts,
  addPromoAlert,
  setPromoAlertQuery,
  setCityRinkQuery,
  promoAlertQuery,
  cityRinkQuery,
  campaignType = 'Promo Alert',
}) => {
  const isCityRink = campaignType === 'City Rink';
  const sectionTitle = isCityRink ? 'City Rink' : 'Promo Alerts';
  const basePath = isCityRink ? '/city-rink' : '/promo-alert';
  const savedQuery = isCityRink
    ? cityRinkQuery
    : {
        ...promoAlertQuery,
        style: promoAlertQuery?.style === 'City Rink' ? '' : promoAlertQuery?.style,
      };
  const setSavedQuery = isCityRink ? setCityRinkQuery : setPromoAlertQuery;
  console.log({ cities });
  useEffect(() => {
    clearRecentPosts();
  }, []);

  const [page, setPage] = useState(1);
  const [digests, setDigests] = useState([]);
  const [count, setCount] = useState(0);
  const [column, setColumn] = useState('sendDate');
  const [direction, setDirection] = useState('DESC');

  const runSearch = async query => {
    const scopedQuery = isCityRink
      ? { ...query, style: 'City Rink' }
      : { ...query, excludeStyle: 'City Rink' };
    setSavedQuery(query);
    const { digests, count } = await api.searchPromoAlerts({ ...scopedQuery, column, direction });
    setCount(count);
    setDigests(digests);
  };

  const search = async query => {
    const firstPageQuery = { ...query, offset: 0 };
    setPage(1);
    return runSearch(firstPageQuery);
  };

  const formik = useFormik({
    initialValues: savedQuery,
    onSubmit: search,
    enableReinitialize: true,
  });

  useEffect(() => {
    formik.handleSubmit();
  }, []);

  const getDate = alert => {
    const sendDate = moment.utc(parseInt(alert.sendDate));
    const sendTime = moment(alert.sendTime, 'hh:mm');

    if (!sendDate.isValid()) return;

    if (sendDate.isValid() && !sendTime.isValid()) {
      return sendDate.format('MMM D, YYYY');
    }

    return `${moment.utc(parseInt(alert.sendDate)).format('MMM D, YYYY')}, ${moment(alert.sendTime, 'hh:mm').format(
      'h:mm a'
    )}`;
  };

  const getDirection = () => {
    if (direction === 'ASC') {
      return 'descending';
    }
    if (direction === 'DESC') {
      return 'ascending';
    }
    return null;
  };

  return (
    <>
      <PageContainer>
        <Menu borderless attached="top">
          <Menu.Item header>{sectionTitle}</Menu.Item>

          <Menu.Menu position="right">
            <Menu.Item>
              {isCityRink ? (
                <Button
                  icon="plus"
                  content="City Rink Email"
                  labelPosition="left"
                  positive
                  onClick={() => addPromoAlert('City Rink')}
                />
              ) : (
                <Dropdown text="New Email" icon="plus" labeled button className="button icon positive">
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => addPromoAlert('Promo Alert')}>Promo Alert</Dropdown.Item>
                    <Dropdown.Item onClick={() => addPromoAlert('Insider Invite')}>Insider Invite</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </Menu.Item>
          </Menu.Menu>
        </Menu>

        <br />

        <Grid>
          <Grid.Column tablet={10} computer={13} centered="true">
            <div style={{ minHeight: 500 }}>
              <Table size="small" compact="very" celled sortable fixed>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell
                      width={8}
                      sorted={column === 'subject' ? getDirection() : null}
                      onClick={() => {
                        if (column !== 'subject') {
                          setDirection(null);
                        }
                        setColumn('subject');
                        setDirection(direction === 'ASC' ? 'DESC' : 'ASC');
                        search(formik.values);
                      }}
                    >
                      Subject line
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      width={2}
                      sorted={column === 'style' ? getDirection() : null}
                      onClick={() => {
                        if (column !== 'style') {
                          setDirection(null);
                        }
                        setColumn('style');
                        setDirection(direction === 'ASC' ? 'DESC' : 'ASC');
                        search(formik.values);
                      }}
                    >
                      Style
                    </Table.HeaderCell>
                    <Table.HeaderCell width={2}>Property</Table.HeaderCell>
                    <Table.HeaderCell width={2}>City</Table.HeaderCell>
                    <Table.HeaderCell
                      width={3}
                      sorted={column === 'sendDate' ? getDirection() : null}
                      onClick={() => {
                        if (column !== 'sendDate') {
                          setDirection(null);
                        }
                        setColumn('sendDate');
                        setDirection(direction === 'ASC' ? 'DESC' : 'ASC');
                        search(formik.values);
                      }}
                    >
                      Send on
                    </Table.HeaderCell>
                    <Table.HeaderCell
                      size={1}
                      sorted={column === 'isScheduled' ? getDirection() : null}
                      onClick={() => {
                        if (column !== 'isScheduled') {
                          setDirection(null);
                        }
                        setColumn('isScheduled');
                        setDirection(direction === 'ASC' ? 'DESC' : 'ASC');
                        search(formik.values);
                      }}
                    >
                      Status
                    </Table.HeaderCell>
                    <Table.HeaderCell width={1}></Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {digests &&
                    digests.map((alert, idx) => (
                      <Table.Row key={idx}>
                        <Table.Cell>
                          <Link to={`${basePath}/create/${alert.id}`}>{alert.subject}</Link>
                        </Table.Cell>
                        <Table.Cell>{alert.style}</Table.Cell>
                        <Table.Cell>{alert?.site?.name}</Table.Cell>
                        <Table.Cell>{alert?.site?.city}</Table.Cell>
                        <Table.Cell>{getDate(alert)}</Table.Cell>
                        <Table.Cell>
                          <PromoStatusLabel digest={alert} />
                        </Table.Cell>
                        <Table.Cell>
                          <Button
                            icon="binoculars"
                            as="a"
                            size="mini"
                            target="_blank"
                            href={`${SERVER_URL}/api/promo-alert/email/${alert.id}`}
                          />
                        </Table.Cell>
                      </Table.Row>
                    ))}
                </Table.Body>
              </Table>
            </div>

            <br />

            <div style={{ display: 'grid', justifyContent: 'center' }}>
              <Pagination
                activePage={page}
                style={{ marginLeft: 'auto', marginRight: 'auto' }}
                totalPages={Math.ceil(count / 10)}
                onPageChange={(e, { activePage }) => {
                  console.log({ page, activePage });
                  const pagedQuery = { ...formik.values, offset: 10 * (activePage - 1) };
                  formik.setValues(pagedQuery);
                  runSearch(pagedQuery);
                  setPage(activePage);
                }}
              />
            </div>
          </Grid.Column>
          <Grid.Column table={6} computer={3}>
            <Form onSubmit={formik.handleSubmit}>
              <div style={{ display: 'grid', alignItems: 'start' }}>
                <Card fluid>
                  <Card.Content>
                    <Form.Field>
                      <label>Subject</label>
                      <Form.Input
                        icon="search"
                        name="subject"
                        value={formik.values.subject}
                        onChange={(e, { value }) => formik.setFieldValue('subject', value)}
                      />
                    </Form.Field>

                    <Form.Field>
                      <label>City</label>
                      <Form.Dropdown
                        name="siteId"
                        className="time-dropdown"
                        clearable
                        value={formik.values.siteId}
                        onChange={(e, { value }) => formik.setFieldValue('siteId', value)}
                        fluid
                        selection
                        options={cities}
                        // options={sites ? [{ key: ' ', value: '', text: 'All' }, ...sites.filter(s => s.key)] : []}
                      />
                    </Form.Field>

                    {!isCityRink && (
                      <Form.Field>
                        <label>Style</label>
                        <Form.Dropdown
                          value={formik.values.style}
                          fluid
                          name="style"
                          clearable
                          selection
                          options={promoAlertFormats}
                          onChange={(e, { value }) => formik.setFieldValue('style', value)}
                        />
                      </Form.Field>
                    )}

                    <Form.Field>
                      <label>Status</label>
                      <Form.Dropdown
                        value={formik.values.status}
                        fluid
                        name="style"
                        clearable
                        // placeholder="All"
                        selection
                        options={['All', 'Scheduled', 'Draft'].map(s => ({ key: s, value: s, text: s }))}
                        onChange={(e, { value }) => formik.setFieldValue('status', value)}
                      />
                    </Form.Field>

                    <br />

                    <Button type="submit" content="Submit" positive fluid />
                    <br />

                    <Button
                      content="Clear"
                      onClick={() => {
                        setSavedQuery();
                        formik.handleSubmit();
                      }}
                      fluid
                    />
                  </Card.Content>
                </Card>
              </div>
            </Form>
          </Grid.Column>
        </Grid>
      </PageContainer>
    </>
  );
};

const mapStateToProps = state => ({
  digests: selectors.getDigests(state),
  promoAlerts: selectors.getPromoAlerts(state),
  cities: selectors.admin.allProperties(state),
  promoAlertFormats: selectors.campaigns.promoAlertFormats(state),
  promoAlertQuery: selectors.campaigns.promoAlertQuery(state),
  cityRinkQuery: selectors.campaigns.cityRinkQuery(state),
});

const mapDispatchToProps = dispatch => ({
  getPromoAlerts: bindActionCreators(actions.campaign.getPromoAlerts, dispatch),
  clearRecentPosts: bindActionCreators(actions.campaign.clearRecentPosts, dispatch),
  deletePromoAlertById: bindActionCreators(actions.campaign.deletePromoAlertById, dispatch),
  searchPromoAlerts: bindActionCreators(actions.campaign.searchPromoAlerts, dispatch),
  addPromoAlert: bindActionCreators(actions.campaign.addPromoAlert, dispatch),
  setPromoAlertQuery: bindActionCreators(actions.campaign.setPromoAlertQuery, dispatch),
  setCityRinkQuery: bindActionCreators(actions.campaign.setCityRinkQuery, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(PromoAlertSearch);
